<!-- <cl-image public-id="badges/{{ name }}.png" [attr.height]="size" [attr.width]="size">
  <cl-transformation *ngIf="!active" effect="brightness:5" ></cl-transformation>
  <cl-transformation *ngIf="!active" effect="grayscale"></cl-transformation>

  <cl-transformation [attr.height]="size * 2" [attr.width]="size * 2" crop="fill" quality="auto:low"></cl-transformation>
</cl-image> -->

<img src="/assets/images/badges/{{ name }}.png" [attr.height]="size" [attr.width]="size" [class.brightness-50]="!active" [class.grayscale]="!active" />
